import React, { Component } from "react";
import PropTypes from "prop-types";
import { actionAppliedCandidateList } from "../Actions/CandidateAction";
import { token } from "../Actions/AuthAction";
import ReactPaginate from "react-paginate";
import { showLoader, hideLoader } from "../../utils";
import { Link } from "react-router-dom";

export default class AllCandidateList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: token(),
      data: [],
      totalCount: 0,
      showModel: false,
      limit: 5,
      currentPage: 0,
      search: "",
      status: 0,
      istrending: "",
      sampleImage:
        "https://www.clipartmax.com/png/small/214-2143742_individuals-whatsapp-profile-picture-icon.png",
    };
  }

  componentDidMount() {
    this.loadList();
  }

  loadList = (init) => {
    const { search, status } = this.state;
    const model = {
      loginusertoken: this.state.token,
      page: this.state.currentPage + 1,
      search: search,
      status: status,
    };
    if (!init && (search || status)) {
      model.page = 0;
      this.setState({
        currentPage: 0,
      });
    }
    showLoader(this);
    actionAppliedCandidateList(model)
      .then((res) => {
        hideLoader(this);
        this.setState({
          totaldata: res.totaldata,
          data: res.data,
          originalData: res.data,
          totalCount: res.totaldata,
        });
      })
      .catch((e) => hideLoader(this));
  };

  handlePageClick = (data) => {
    let selected = data.selected;
    this.setState(
      {
        currentPage: selected,
      },
      () => {
        this.loadList(true);
      }
    );
  };

  render() {
    const { data, totalCount, limit, sampleImage } = this.state;
    return (
      <>
        <div className="row mb-4">
          <div className="col-md-12">
            <h4 className="table_heading position-relative">
              SELECTED CANDIDATES LIST
            </h4>
          </div>
        </div>
        <div className="card table_card mb-4">
          <div className="card-body">
            <div className="">
              <form className="d-flex justify-content-between form-group tableform">
                <div>
                  <select className="form-control">
                    <option>Filter</option>
                    <option value="">All</option>
                    <option>Pending</option>
                    <option>Approve</option>
                    <option>Rejected</option>
                  </select>
                </div>
                <div className="search-box mb-2">
                  <input
                    className="search-text"
                    type="text"
                    placeholder="Search in table"
                  />
                  <a href="#" className="search-btn">
                    <i className="fas fa-search"></i>
                  </a>
                </div>
              </form>
            </div>
            <div className="table-responsive">
              <table
                className="table table-bordered"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Logo</th>
                    <th>Roll Number</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Institute Name</th>
                    <th>University Name</th>

                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data
                    ? this.state.data.map((item, i) => (
                        <tr>
                          <td>
                            {this.state.currentPage * this.state.limit + ++i}
                          </td>
                          <td>
                            <img
                              src={`${
                                item.candidate.profile_url
                                  ? item.candidate.profile_url
                                  : sampleImage
                              }`}
                              alt="Image not available"
                              width="24px"
                            />
                          </td>
                          <td>{item.candidate.rollnumber}</td>
                          <td>{item.candidate.firstname}</td>
                          <td>{item.candidate.user.email}</td>
                          <td>{item.candidate.user.phone}</td>

                          <td>{item.candidate.inst.name}</td>
                          <td>{item.candidate.uni.university_name}</td>

                          <td>
                            <span className="tabledropdown">
                              <span className="abtn">
                                <i
                                  class="fa fa-ellipsis-v"
                                  id="dropdownMenuLink"
                                  data-toggle="dropdown"
                                ></i>
                                <div
                                  class="dropdown-menu editdrp"
                                  aria-labelledby="dropdownMenuLink"
                                >
                                  <Link
                                    class="dropdown-item"
                                    to={`/profile/${item.candidate_id}`}
                                  >
                                    View Profile
                                  </Link>
                                  <Link
                                    class="dropdown-item"
                                    to={`/candidatedetail/${item.drive_id}/${item.candidate_id}`}
                                  >
                                    View Details
                                  </Link>
                                </div>
                              </span>
                            </span>
                          </td>
                        </tr>
                      ))
                    : null}

                  {/* <tr>
                                                    <td>Shad Decker</td>
                                                    <td>Regional Director</td>
                                                    <td>Edinburgh</td>
                                                    <td>51</td>
                                                    <td>2008/11/13</td>
                                                    <td>$183,000</td>
                                                    <td><span className="text-success font-weight-bold">Approved</span></td>
                                                    <td className="text-center position-relative">
                                                        <span id="tablepopup" className="tabledropdown"><a href="#" className="abtn"><i className="fa fa-ellipsis-v" aria-hidden="true"></i></a>
                                                        <div className="table-popup">
                                                            <ul>
                                                                <li><a href="#">Edit</a></li>
                                                                <li><a href="#">Delete</a></li>
                                                            </ul>
                                                        </div>
                                                    </span>
                                                    </td>
                                                </tr>                                              
                                                <tr>
                                                    <td>Shad Decker</td>
                                                    <td>Regional Director</td>
                                                    <td>Edinburgh</td>
                                                    <td>51</td>
                                                    <td>2008/11/13</td>
                                                    <td>$183,000</td>
                                                    <td><span className="text-danger font-weight-bold">Rejected</span></td>
                                                    <td className="text-center position-relative">
                                                        <span id="tablepopup" className="tabledropdown"><a href="#" className="abtn"><i className="fa fa-ellipsis-v" aria-hidden="true"></i></a>
                                                        <div className="table-popup">
                                                            <ul>
                                                                <li><a href="#">Edit</a></li>
                                                                <li><a href="#">Delete</a></li>
                                                            </ul>
                                                        </div>
                                                    </span>
                                                    </td>
                                                </tr>                                              
                                                <tr>
                                                    <td>Shad Decker</td>
                                                    <td>Regional Director</td>
                                                    <td>Edinburgh</td>
                                                    <td>51</td>
                                                    <td>2008/11/13</td>
                                                    <td>$183,000</td>
                                                    <td><span className="text-warning font-weight-bold">Pending</span></td>
                                                    <td className="text-center position-relative">
                                                        <span id="tablepopup" className="tabledropdown"><a href="#" className="abtn"><i className="fa fa-ellipsis-v" aria-hidden="true"></i></a>
                                                        <div className="table-popup">
                                                            <ul>
                                                                <li><a href="#">Edit</a></li>
                                                                <li><a href="#">Delete</a></li>
                                                            </ul>
                                                        </div>
                                                    </span>
                                                    </td>
                                                </tr>                                              
                                                <tr>
                                                    <td>Shad Decker</td>
                                                    <td>Regional Director</td>
                                                    <td>Edinburgh</td>
                                                    <td>51</td>
                                                    <td>2008/11/13</td>
                                                    <td>$183,000</td>
                                                    <td><span className="text-success font-weight-bold">Approved</span></td>
                                                    <td className="text-center position-relative">
                                                        <span id="tablepopup" className="tabledropdown"><a href="#" className="abtn"><i className="fa fa-ellipsis-v" aria-hidden="true"></i></a>
                                                        <div className="table-popup">
                                                            <ul>
                                                                <li><a href="#">Edit</a></li>
                                                                <li><a href="#">Delete</a></li>
                                                            </ul>
                                                        </div>
                                                    </span>
                                                    </td>
                                                </tr> */}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between">
              <h6>
                <span>{`${
                  this.state.currentPage
                    ? this.state.currentPage * this.state.limit + 1
                    : 1
                }-${
                  data.length < limit
                    ? totalCount
                    : (this.state.currentPage + 1) * this.state.limit
                }`}</span>{" "}
                <span>/ {this.state.totalCount} Search Results</span>
              </h6>
              <div class="pagination">
                <ReactPaginate
                  previousLabel={
                    <i
                      className="fa fa-angle-double-left"
                      aria-hidden="true"
                    ></i>
                  }
                  nextLabel={
                    <i
                      className="fa fa-angle-double-right"
                      aria-hidden="true"
                    ></i>
                  }
                  pageCount={
                    this.state.totalCount % this.state.limit === 0
                      ? parseInt(this.state.totalCount / this.state.limit)
                      : parseInt(this.state.totalCount / this.state.limit) + 1
                  }
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={10}
                  onPageChange={this.handlePageClick}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
